import { ValueService } from "@dqm/value-observer";
import React, { useState } from "react";
import EnqueueActions from "./containers/EnqueueActions";
import { UiStatusProvider } from "./services/uiStatus/UiStatusProvider";
import FaultDialogWrapper from "./containers/FaultDialogWrapper";
import InfoContainer from "./containers/InfoContainer";
import TopBar from "./containers/TopBar";
import { EnqueueService } from "./services/enqueue";
import { PrintingService } from "./services/print";
import { PrintStatus } from "./constants/PrintStatus";
import PrintAnimationWrapper from "./containers/PrintAnimationWrapper";
import { HiddenButton } from "./containers/LootBox/HiddenButton";
import { UiStatusService } from "./services/uiStatus/UiStatusService";

export interface Props {
  uiStatusService: UiStatusService;
  enqueueService: EnqueueService;
  valueService: ValueService;
  printingService: PrintingService;
}

const App: React.FC<Props> = ({
  uiStatusService,
  valueService,
  enqueueService,
  printingService,
}) => {
  const [printStatus, setPrintStatus] = useState<PrintStatus>(PrintStatus.NONE);
  const [isLootBoxVisible, setIsLootBoxVisible] = useState(false);

  return (
    <div className="dqm-tcui-app">
      <UiStatusProvider service={uiStatusService}>
        <TopBar valueService={valueService} />
        <main className="dqm-tcui-main">
          <FaultDialogWrapper valueService={valueService}>
            <InfoContainer
              isLootBoxVisible={isLootBoxVisible}
              hideLootBox={() => {
                setIsLootBoxVisible(false);
              }}
            />
            <EnqueueActions
              valueService={valueService}
              enqueueService={enqueueService}
              printingService={printingService}
              onPrinterStatusChange={setPrintStatus}
            />
            {!isLootBoxVisible && (
              <HiddenButton showLootBox={() => setIsLootBoxVisible(true)} />
            )}
          </FaultDialogWrapper>
        </main>
        <PrintAnimationWrapper status={printStatus} />
      </UiStatusProvider>
    </div>
  );
};

export default App;
